import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactDayPicker from 'react-day-picker';
import { injectIntl } from 'react-intl';

import { NavBar } from './NavBar';
import { modifiersStyles } from './utils/modifiersStyles';
import { isValidDay } from './utils/dateTimeHelpers';
import reactDayPickerStyles from './reactDayPickerStyles.css';

const ReactDayPickerWrapper = ({ onChangeDay, selectedDay, intl }) => {
  const today = new Date();
  const [todayY, todayM, todayD] = today.toISOString().split('T')[0];
  const [selectedCalendarDay, setSelectedCalendarDay] = useState('');
  const [year, setYear] = useState(todayY);
  const [month, setMonth] = useState(todayM);

  const modifiers = {
    disabled: { before: today },
  };

  // We have to resort the days, because ReactDayPicker needs the first item to be sunday
  const getWeekdays = (id) => {
    const days = intl.formatMessage({ id }).split(',');

    return [days[6], ...days.slice(0, 6)];
  };

  const handleChangeDay = (date, { disabled }, event) => {
    event.preventDefault();
    // without this, the alerts card would close itself
    event.nativeEvent.stopImmediatePropagation();

    if (!disabled) {
      onChangeDay(date);
    }
  };

  useEffect(() => {
    if (isValidDay(selectedDay)) {
      // we have to transform this kind of date 2021-05-13 back to a JS Date
      // Object for the ReactDayPicker
      const selectedDayYMD = selectedDay.split('-');

      setSelectedCalendarDay(new Date([...selectedDayYMD]));
      setYear(selectedDayYMD[0]);
      setMonth(selectedDayYMD[1]);
    } else {
      setSelectedCalendarDay(new Date([todayY, todayM, todayD]));
      setYear(todayY);
      setMonth(todayM);
    }
  }, [selectedDay]);

  return (
    <ReactDayPicker
      classNames={reactDayPickerStyles}
      firstDayOfWeek={1}
      locale={intl.locale}
      modifiers={modifiers}
      modifiersStyles={modifiersStyles}
      // for some reason 1 needs to be substracted *shrug*
      // check the example here: https://react-day-picker.js.org/examples/months-initial
      month={new Date(year, month - 1)}
      months={intl.formatMessage({ id: 'MONTH_NAMES' }).split(',')}
      onDayClick={handleChangeDay}
      selectedDays={selectedCalendarDay}
      weekdaysShort={getWeekdays('DAY_NAMES_SHORT')}
      navbarElement={<NavBar />}
    />
  );
};

ReactDayPickerWrapper.propTypes = {
  intl: PropTypes.object,
  onChangeDay: PropTypes.func,
  selectedDay: PropTypes.string,
};

const DayPicker = injectIntl(ReactDayPickerWrapper);

export { DayPicker };
